import type { Card, GameState } from '../game/types';
import { pickBlackhandCard } from './blackhand';
import { pickChymistCard } from './chymist';
import { pickDarkApostleCard } from './darkApostle';
import { pickDreadbrandCard } from './dreadbrand';
import { hasGenericEnemyAi, pickGenericEnemyCard } from './generic';
import { pickLampKeeperCard } from './lampKeeper';
import { pickMercenaryCard } from './mercenary';
import { pickCustodianCard } from './custodian';
import { pickThresholdVerifierCard } from './thresholdVerifier';
import type { EnemyAiDecision, EnemyAiModule } from './types';

function norm(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

const enemyAiRegistry: Record<string, EnemyAiModule> = {
  blackhand: { pickCard: pickBlackhandCard },
  mercenary: { pickCard: pickMercenaryCard },
  custodian: { pickCard: pickCustodianCard },
  lamp_keeper: { pickCard: pickLampKeeperCard },
  chymist: { pickCard: pickChymistCard },
  'dark-apostle': { pickCard: pickDarkApostleCard },
  dreadbrand: { pickCard: pickDreadbrandCard },
  threshold_verifier: { pickCard: pickThresholdVerifierCard },
};

function getEnemyAiModule(enemyId: string | undefined | null): EnemyAiModule | null {
  const key = norm(enemyId);
  return enemyAiRegistry[key] ?? null;
}

export function hasEnemyAiRouting(enemyId: string | undefined | null): boolean {
  return !!getEnemyAiModule(enemyId) || hasGenericEnemyAi(enemyId);
}

export function chooseEnemyCardViaAi(state: GameState, enemyDeck: Card[], availableCards: Card[], preview = false): EnemyAiDecision | null {
  const module = getEnemyAiModule(state.enemyId);
  const decision = module
    ? module.pickCard({ state, enemyDeck, availableCards, preview })
    : hasGenericEnemyAi(state.enemyId)
      ? pickGenericEnemyCard({ state, enemyDeck, availableCards, preview })
      : null;
  if (!decision?.card) return decision;
  const chosenId = String(decision.card.id ?? '');
  const chosen = availableCards.find((card) => String(card.id ?? '') === chosenId)
    ?? availableCards.find((card) => String(card.title ?? '') === String(decision.card?.title ?? ''))
    ?? null;
  return { ...decision, card: chosen };
}
